import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import OtpInput from "react-otp-input";
import { verifyOtp, resendOtp } from "../../services/AuthenticationAPIs";

const Otp: React.FC = () => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const api_key = localStorage.getItem("api_key")?.trim();
  const user_id = localStorage.getItem("user_id");
  const tenant_id = localStorage.getItem("tenant_id");
  const email = localStorage.getItem("email");

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleVerifyBtn = async () => {
    if (!otp || otp.length !== 6) {
      message.warning("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    try {
      const result = await verifyOtp({
        api_key,
        user_id,
        tenant_id,
        email,
        code: otp,
      });

      if (result.status) {
        message.success(result.message || "Verification successful!");
        navigate("/welcome-to-datatram/basic-information" , { state: { from: "welcome" } });
      } else {
        message.error(
          result.message || "Verification failed. Please try again."
        );
      }
    } catch {
      message.error(
        "Network error. Please check your connection and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      const result = await resendOtp(email, api_key);
      if (!result.status) {
        message.warning(
          result.message || "Failed to resend OTP. Please try again."
        );
      }
    } catch {
      message.error("Network error. Please try again later.");
    }
  };

  return (
    <div className="body noScroll" style={{ backgroundImage: `url(/images/DatatramSignup.png)` }}>
      <img src="/images/DpLogo.png" className="logo-design" alt="logo" />
      <div className="app">
        <form className="formdesign">
          <div className="items-center">
            <img src="/images/NewEmail.png" className="new-email" alt="NewEmail" />
            <h2 className="entercode">Enter The Code</h2>
            <p className="Otp-Detail">
              A verification email has been sent to your email address. Please
              enter the code below to continue.
            </p>

            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={<span style={{ color: "#38ABD2" }}>-</span>}
              renderInput={props => (
                <div className="otp-block-row">
                  <input {...props} className="otp-boxes" />
                </div>
              )}
            />

            <button
              className="mt-5 button-otp"
              id="verify-acc"
              onClick={handleVerifyBtn}
              type="button"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify Account"}
            </button>

            <p className="resend-email">
              Didn’t receive the email?&nbsp;
              <button
                className="resend-button"
                onClick={e => {
                  e.preventDefault();
                  handleResendOtp();
                }}
                type="button"
              >
                Resend
              </button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Otp;
